import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Insurance } from 'models/InsuranceModel';


const InsuranceList: React.FC = () => {
  const width = { client: 30, policy: 15, member: 15, insurer: 44 }
  const [formId, formName] = [Code.Form.Id.INSURANCE, Code.Form.Name.INSURANCE];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [insuranceData, setInsuranceData] = useState<Insurance[]>([]); 
  const [selectedInsurance, setselectedInsurance] = useState<Insurance | null>(null);
  const [insurerId, setInsurerId] = useState<number>(1);
  const [insurerOptions, setInsurerOptions] = Hooks.Form.Options();
  const triggers = [pno, pageRows, search, activeId, insurerId];
  const Privilege = Hooks.Privilege.List(formId);
  const PrivClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  
  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.INSURER, Code.Option.Common.ALL, setInsurerOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Insurance.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Insurance.Id, 
        Name.Client.FullName, 
        Name.Insurance.PolicyNumber, 
        Name.Insurance.memberNumber, 
        Name.Insurer.Name, 
      ]),
      insurer_id: insurerId,
    });
     
    await API.Data.List<Insurance>(url, setInsuranceData, setError, setLoading); 
  }, triggers);

  

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Insurer} value={insurerId} options={insurerOptions} onChange={(value) => { setInsurerId(value);  callListData();  }} />
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, insuranceData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.ClientName, width.client], 
                [Title.PolicyNumber, width.policy], 
                [Title.MemberNumber, width.member],
                [Title.Insurer, width.insurer], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(insuranceData) && (
              <Control.Grid.Row>
                {insuranceData.map((insuranceData) => { return (
                <Control.Grid.Data<Insurance> key={insuranceData.insurance_id} itemKey={insuranceData.insurance_key} data={insuranceData} setMenuPosition={setMenuPosition} setSelectedData={setselectedInsurance} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={insuranceData.insurance_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, insuranceData.insurance_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Link value={Utility.Get.FullName(insuranceData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(PrivClient, Code.Form.Name.CLIENT, insuranceData.client_id)} width={width.client} iframeRef={iframeRef} /> 
                  <Control.Grid.Items values={[
                    [insuranceData.insurance_policy_number, width.policy],
                    [insuranceData.insurance_member_number, width.member],
                    [insuranceData.insurer_name, width.insurer],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={insuranceData.insurance_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={insuranceData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName, selectedInsurance?.insurance_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedInsurance?.insurance_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default InsuranceList;